import React, { useMemo } from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function WaterfallChart({ data }) {
    const { categories, invisible, positive, negative } = useMemo(() => {
        const cats = []
        const inv = []
        const pos = []
        const neg = []
        let running = 0

        data.forEach((item) => {
            cats.push(item.label)

            if (item.isTotal) {
                inv.push(0)
                pos.push(item.value)
                neg.push(0)
                running = item.value
            } else if (item.value >= 0) {
                inv.push(running)
                pos.push(item.value)
                neg.push(0)
                running += item.value
            } else {
                const absVal = Math.abs(item.value)
                running -= absVal
                inv.push(running)
                pos.push(0)
                neg.push(absVal)
            }
        })

        return { categories: cats, invisible: inv, positive: pos, negative: neg }
    }, [data])

    const options = {
        chart: {
            type: 'bar',
            stacked: true,
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                columnWidth: '50%',
                borderRadius: 4,
            },
        },
        xaxis: {
            categories,
            labels: {
                style: { colors: '#64748B', fontSize: '10px' },
                rotate: -30,
                rotateAlways: true,
            },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        colors: ['transparent', '#3B82F6', '#EF4444'],
        legend: { show: false },
        tooltip: {
            theme: 'light',
            intersect: true,
            shared: false,
            custom: ({ seriesIndex, dataPointIndex }) => {
                const item = data[dataPointIndex]
                const color = item.isTotal ? '#64748B' : (item.isPositive ? '#3B82F6' : '#EF4444')
                return `<div style="padding:8px 12px;font-size:13px">
                    <strong>${item.label}</strong><br/>
                    <span style="color:${color}">${formatCurrency(item.value)}</span>
                </div>`
            },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: { enabled: false },
        fill: {
            type: 'solid',
            opacity: [0, 1, 1],
        },
    }

    const series = [
        { name: 'Base', data: invisible },
        { name: 'Positivo', data: positive },
        { name: 'Negativo', data: negative },
    ]

    return (
        <ChartCard title="DRE Visual" subtitle="Demonstrativo de Resultado (Cascata)">
            <Chart options={options} series={series} type="bar" height={320} />
        </ChartCard>
    )
}
